import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IntroDivider from './IntroDivider';
import ClientProvider from './client';
export default createDemo(import.meta.url, IntroDivider, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dividers/demos/intro/IntroDivider.tsx",
    "fileName": "IntroDivider.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Card from '@mui/material/Card';\nimport Box from '@mui/material/Box';\nimport Chip from '@mui/material/Chip';\nimport Stack from '@mui/material/Stack';\nimport Divider from '@mui/material/Divider';\nimport Typography from '@mui/material/Typography';\n\nexport default function IntroDivider() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Card variant=\"outlined\" sx={{ maxWidth: 360 }}>\n      <Box sx={{ p: 2 }}>\n        <Stack\n          direction=\"row\"\n          sx={{ justifyContent: 'space-between', alignItems: 'center' }}\n        >\n          <Typography gutterBottom variant=\"h5\" component=\"div\">\n            Toothbrush\n          </Typography>\n          <Typography gutterBottom variant=\"h6\" component=\"div\">\n            $4.50\n          </Typography>\n        </Stack>\n        <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n          Pinstriped cornflower blue cotton blouse takes you on a walk to the park or\n          just down the hall.\n        </Typography>\n      </Box>\n      <Divider />\n      <Box sx={{ p: 2 }}>\n        <Typography gutterBottom variant=\"body2\">\n          Select type\n        </Typography>\n        <Stack direction=\"row\" spacing={1}>\n          <Chip color=\"primary\" label=\"Soft\" size=\"small\" />\n          <Chip label=\"Medium\" size=\"small\" />\n          <Chip label=\"Hard\" size=\"small\" />\n        </Stack>\n      </Box>\n    </Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 41,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Card from '@mui/material/Card';\nimport Box from '@mui/material/Box';\nimport Chip from '@mui/material/Chip';\nimport Stack from '@mui/material/Stack';\nimport Divider from '@mui/material/Divider';\nimport Typography from '@mui/material/Typography';\n\nexport default function IntroDivider() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Card variant=\"outlined\" sx={{ maxWidth: 360 }}>\n      <Box sx={{ p: 2 }}>\n        <Stack\n          direction=\"row\"\n          sx={{ justifyContent: 'space-between', alignItems: 'center' }}\n        >\n          <Typography gutterBottom variant=\"h5\" component=\"div\">\n            Toothbrush\n          </Typography>\n          <Typography gutterBottom variant=\"h6\" component=\"div\">\n            $4.50\n          </Typography>\n        </Stack>\n        <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n          Pinstriped cornflower blue cotton blouse takes you on a walk to the park or\n          just down the hall.\n        </Typography>\n      </Box>\n      <Divider />\n      <Box sx={{ p: 2 }}>\n        <Typography gutterBottom variant=\"body2\">\n          Select type\n        </Typography>\n        <Stack direction=\"row\" spacing={1}>\n          <Chip color=\"primary\" label=\"Soft\" size=\"small\" />\n          <Chip label=\"Medium\" size=\"small\" />\n          <Chip label=\"Hard\" size=\"small\" />\n        </Stack>\n      </Box>\n    </Card>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 41,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Card",
      "@mui/material/Box",
      "@mui/material/Chip",
      "@mui/material/Stack",
      "@mui/material/Divider",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
